import { getEnvVars } from '@order/utils';

export const getKustomerKeys = () => {
  const { KUSTOMER_API_KEY, KUSTOMER_BRAND_ID } = getEnvVars();
  const apiKey = KUSTOMER_API_KEY;
  const brandId = KUSTOMER_BRAND_ID;

  return { apiKey, brandId };
};
